import { IList, useNavigator, useStreamValue } from 'annotation-tools/utils';
import { useCallback, useEffect, useRef } from 'react';
import {
  companyId$,
  koumutenId$,
  projectId$
} from '../../../../global-state/router-id';
import { routes } from '../../../../routing/routes';
import { IProjectImageInfoType } from '../../../../types/record/image-info';

export const useHandlers = (imageList: IList<IProjectImageInfoType>) => {
  const navigator = useNavigator();
  const koumutenId = useStreamValue(koumutenId$);
  const companyId = useStreamValue(companyId$);
  const projectId = useStreamValue(projectId$);

  const ref = useRef<{
    navigator: undefined | ((pathname: string) => void);
    koumutenId: undefined | number;
    companyId: undefined | number;
    projectId: undefined | number;
    imageList: undefined | IList<IProjectImageInfoType>;
  }>({
    navigator: undefined,
    koumutenId: undefined,
    companyId: undefined,
    projectId: undefined,
    imageList: undefined
  });

  useEffect(() => {
    ref.current = {
      navigator,
      koumutenId,
      companyId,
      projectId,
      imageList
    };
  }, [navigator, koumutenId, companyId, projectId, imageList]);

  const onPageIndexChange = useCallback((pageIndex: number) => {
    const rf = ref.current;
    if (
      pageIndex === undefined ||
      rf.koumutenId === undefined ||
      rf.companyId === undefined ||
      rf.projectId === undefined ||
      rf.imageList === undefined ||
      rf.navigator === undefined ||
      pageIndex < 0 ||
      rf.imageList.size < pageIndex
    ) {
      return;
    }
    const nextImageId = rf.imageList.get(pageIndex)?.id;
    if (nextImageId === undefined) return;

    rf.navigator(
      routes.projectImageRoot(
        rf.koumutenId,
        rf.companyId,
        rf.projectId,
        nextImageId
      )
    );
  }, []);

  const onBackToListPageClick = useCallback(() => {
    const rf = ref.current;
    if (
      rf.koumutenId !== undefined &&
      rf.companyId !== undefined &&
      rf.projectId !== undefined &&
      rf.navigator !== undefined
    ) {
      rf.navigator(
        routes.projectImageList(rf.koumutenId, rf.companyId, rf.projectId)
      );
    }
  }, []);

  return { onPageIndexChange, onBackToListPageClick };
};
